import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ModalStyle.css";
import middleware from "../Api/Middleware";
import { BorderedDropDown } from '../HouseStyle/Components/DropDowns';
import { formatPercentage, getCountryName } from '../../utils';
import { ButtonBlue, ButtonLightGrey } from "../HouseStyle/Components/Buttons"
import ToastSuccess from "../Toasts/ToastSuccess";

const VATModal = ({ taxEdit, setTaxEdit, taxEditData, fetchAll }) => {
	const [zero, setZero] = useState(taxEditData.zero_percentage);
	const [high, setHigh] = useState(taxEditData.high_percentage);
	const [reduced, setReduced] = useState(taxEditData.reduced_percentage);
	const [reduced2, setReduced2] = useState(taxEditData.reduced2_percentage);
	const [reduced3, setReduced3] = useState(taxEditData.reduced3_percentage);
	const [isEditing, setIsEditing] = useState(false);
	const [selectedReduced, setSelectedReduced] = useState(null)

	useEffect(() => {
		if (taxEdit && taxEditData) {
			setHigh(taxEditData.high_percentage);
			setZero(taxEditData.zero_percentage);
			setReduced(taxEditData.reduced_percentage);
			setReduced2(taxEditData.reduced2_percentage);
			setReduced3(taxEditData.reduced3_percentage);
			setSelectedReduced(taxEditData.selected_reduced ? Number(taxEditData.selected_reduced) : null);
			setIsEditing(true);
		}
	}, [taxEdit, taxEditData]);

	const dropDownOptions = [];
	if (reduced !== null && reduced !== undefined) {
		dropDownOptions.push({ title: `${formatPercentage(reduced)}`, value: taxEditData.reduced_tax_id });
	}
	if (reduced2 !== null && reduced2 !== undefined) {
		dropDownOptions.push({ title: `${formatPercentage(reduced2)}`, value: taxEditData.reduced2_tax_id });
	}
	if (reduced3 !== null && reduced3 !== undefined) {
		dropDownOptions.push({ title: `${formatPercentage(reduced3)}`, value: taxEditData.reduced3_tax_id });
	}

	const updateSelected = async (newVal) => {
		setSelectedReduced(newVal)
	}

	const onSave = async () => {
		try {
			await middleware.put(
				`products/taxrates`, {
				tax_id: selectedReduced,
				selected: 1
			}
			);

			fetchAll();
			ToastSuccess("BTW instellingen bijgewerkt");
		} catch (error) {
			console.error(error);
		}
		setTaxEdit(false);
	}

	const onHide = () => {
		setTaxEdit(false);
	}	

	return (
		<>
			<Modal
				id="modalEditTax"
				show={taxEdit}
				onHide={() => setTaxEdit(false)}
				centered
				size="xl"
			>
				<Modal.Header className="modalTop d-flex justify-content-between">
					<Modal.Title className='BlockTitle'>
						{`Selecteer standaard waardes voor ${getCountryName(taxEditData.country_code_2)}`}
					</Modal.Title>

					<button
						className="border-0 bg-transparent"
						variant="transparent"
						onClick={() => setTaxEdit(false)}
					>
						<FontAwesomeIcon icon={faXmark} className="closeModal" />
					</button>
				</Modal.Header>
				<Modal.Body className="modalCenter">
					<div className="contendModal w-100">

						<label className="FlatText fw-bold">Hoog</label>
						<p className='ps-2'>{formatPercentage(high)}</p>

						{((reduced2 === undefined || reduced2 === null || reduced2 === '') &&
							(reduced3 === undefined || reduced3 === null || reduced3 === '')) ? (
							<div>
								<label className="FlatText fw-bold">Laag</label>
								<p className='ps-2'>{formatPercentage(reduced)}</p>
							</div>
						) : (
							<div className='mb-4'>
								<label className="FlatText fw-bold">Laag</label>
								<BorderedDropDown
									placeholder={formatPercentage(selectedReduced)}
									options={dropDownOptions}
									selectedValue={selectedReduced}
									setSelectedValue={updateSelected}
								/>
							</div>
						)}

						<label className="FlatTex fw-bold">Overig</label>
						<p className='ps-2 mb-0'>{formatPercentage(zero)}</p>
					</div>
				</Modal.Body>
				<Modal.Footer className="modalBottom d-flex justify-content-between">
					<ButtonLightGrey text="Annuleren" onClickFunction={onHide} />
					<ButtonBlue text="Opslaan" onClickFunction={onSave} />
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default VATModal;